import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-734 — Loading skeletons for the Channel dashboard populated body.
 *
 * Rendered during the window/metric/sort partial reload swap (client-side
 * loading — NOT a server state). Skeletons MATCH the populated layout (4
 * KPI tiles, one chart block, 5 table rows) so there is no layout shift and
 * no spinner (UX Spec §3 "Loading").
 */
export function ChannelKpiStripSkeleton() {
  return (
    <section
      className="grid grid-cols-2 gap-4 lg:grid-cols-4"
      data-testid="channel-kpi-strip-skeleton"
      aria-hidden
    >
      {Array.from({ length: 4 }).map((_, i) => (
        <Card key={i} className="rounded-xl border p-5">
          <CardContent className="flex flex-col gap-2 p-0">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-20" />
          </CardContent>
        </Card>
      ))}
    </section>
  )
}

export function ChannelGrowthChartSkeleton() {
  return (
    <Card
      className="flex flex-col gap-3 p-4 sm:p-6"
      data-testid="channel-growth-chart-skeleton"
      aria-hidden
    >
      <Skeleton className="h-5 w-40" />
      <Skeleton className="h-[200px] w-full sm:h-[240px] lg:h-[260px]" />
    </Card>
  )
}

export function ChannelVideosTableSkeleton() {
  return (
    <Card
      className="flex flex-col gap-3 p-4 sm:p-6"
      data-testid="channel-videos-table-skeleton"
      aria-hidden
    >
      <Skeleton className="h-5 w-40" />
      <div className="flex flex-col gap-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3">
            <Skeleton className="h-10 w-10 rounded-md" />
            <Skeleton className="h-4 flex-1" />
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-4 w-12" />
          </div>
        ))}
      </div>
    </Card>
  )
}

/** The full populated-body skeleton set (strip + chart + table). */
export function ChannelPopulatedSkeleton() {
  return (
    <div
      className="flex flex-col gap-6"
      data-testid="channel-analytics-loading"
    >
      <ChannelKpiStripSkeleton />
      <ChannelGrowthChartSkeleton />
      <ChannelVideosTableSkeleton />
    </div>
  )
}
